import { Selector } from '@ngxs/store';

import { BcStateListContext, Spinner } from '@bayclubs/state';
import { ContextCourtModel, EnumerationModel } from '@bayclubs/court-booking-employee-api';

import { BlockedSlotSaveStateModel } from './blocked-slot-save.state.model';
import { BlockedSlotSaveState } from './blocked-slot-save.state';

export class BlockedSlotSaveSelectors {
    @Selector([BlockedSlotSaveState])
    static getSpinner(state: BlockedSlotSaveStateModel): Spinner {
        return state.spinner;
    }

    @Selector([BlockedSlotSaveState])
    static isFormValid(state: BlockedSlotSaveStateModel): boolean {
        return state.form.status === 'VALID';
    }

    @Selector([BlockedSlotSaveState])
    static clubCourts(state: BlockedSlotSaveStateModel): BcStateListContext<ContextCourtModel> {
        return state.clubCourts;
    }

    @Selector([BlockedSlotSaveState])
    static blockedSlotTypes(state: BlockedSlotSaveStateModel): BcStateListContext<EnumerationModel> {
        return state.blockedSlotTypes;
    }

    @Selector([BlockedSlotSaveState])
    static isDateSelected(state: BlockedSlotSaveStateModel): boolean {
        return state.form.model.date !== null;
    }

    @Selector([BlockedSlotSaveState])
    static showSpinner(state: BlockedSlotSaveStateModel): boolean {
        return state.spinner.visible || state.clubCourts.isLoading;
    }
}
